module.exports = __webpack_public_path__ + "img/step3-01.83c8c0d1.jpg";